import React from "react";
import {
  addMinutes,
  endOfDay,
  isBefore,
  isSameDay,
  roundToNearestMinutes,
} from "date-fns";
import BatteryStatus from "./BatteryStatus";
import DateHelper from "../DateHelper/DateHelper";
import DeviceConnectionStatus from "./DeviceConnectionStatus";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import Errors from "../Errors/Errors";
import ReservationSegmentCardActions from "../ReservationSegmentCard/actions/ReservationSegmentCardActions";
import TimePickerInput from "../TimePickerInput/TimePickerInput";
import I18n from "i18n-js";

export default class LocksCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      devices: null,
      errors: [], //["Cannot active a lock after its check out date."],
      loading: false,
      override_check_in_time: roundToNearestMinutes(new Date(), {
        nearestTo: 10,
        roundingMethod: "ceil",
      }),
      show_activate_override: false,
    };

    this.onActivateLocks = this.onActivateLocks.bind(this);
    this.onActivateLockOverride = this.onActivateLockOverride.bind(this);
    this.onChangeOverrideCheckInTime =
      this.onChangeOverrideCheckInTime.bind(this);
    this.onToggleShowActiveOverride =
      this.onToggleShowActiveOverride.bind(this);
  }

  componentDidMount() {
    // load devices
    const { reservation_segment } = this.props;

    if (reservation_segment) {
      var { room } = reservation_segment;
    } else {
      var { room } = this.props;
    }

    if (!this.state.devices && room && room.lock_management === "remotelock") {
      this.loadDevices();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (this.props.reservation_segment &&
        prevProps.reservation_segment &&
        this.props.reservation_segment.room &&
        prevProps.reservation_segment.room &&
        this.props.reservation_segment.room.id !==
          prevProps.reservation_segment.room.id) ||
      (prevProps.reservation_segment &&
        !prevProps.reservation_segment.room &&
        this.props.reservation_segment &&
        this.props.reservation_segment.room)
    ) {
      this.loadDevices();
    }
  }

  /**
   * Render functions
   */

  render() {
    return (
      <div className="LocksCard">
        <div className="panel panel-default" style={this.props.panelStyle}>
          <div className="panel-heading flexed">
            <div className="col-md-6 panel-title-wrapper">
              <h3 className="panel-title" style={{ padding: "0.4rem 0.25rem" }}>
                {I18n.t("locks")}
              </h3>
            </div>
            {this.renderButtons()}
          </div>
          <div className="panel-body container">{this.renderBody()}</div>
        </div>
        <LoadingSpinner show={this.state.loading} size="small" />
      </div>
    );
  }

  renderAccessTimes(room_lock) {
    const { date_format, time_format } = this.props;
    const combined_format = `${date_format} ${time_format}`;
    const check_in_date = this.getLockStartDate(room_lock);
    const check_out_date = this.getLockEndDate(room_lock);
    if (check_in_date && check_in_date) {
      return (
        <span>
          {DateHelper.printDateToScreen(check_in_date, combined_format)}{" "}
          <span style={{ textTransform: "lowercase" }}>{I18n.t("to")}</span>{" "}
          {DateHelper.printDateToScreen(check_out_date, combined_format)}
        </span>
      );
    } else {
      return <div>{I18n.t("not_set")}</div>;
    }
  }

  renderButtons() {
    const { read_only = false, reservation_segment = {} } = this.props;
    const { room = {} } = reservation_segment;

    if (
      !read_only &&
      reservation_segment &&
      room &&
      room.lock_management === "remotelock"
    ) {
      const canReactivateLocks = room.occupancy_status === "vacant";
      const isCheckOutSameDay = this.isCheckOutSameDay();
      const isRemoteLockActive = this.isRemoteLockActive();
      const buttons = [];

      if (isCheckOutSameDay && canReactivateLocks && !isRemoteLockActive) {
        buttons.push(
          <button
            key="activate"
            type="button"
            className={"btn btn-secondary btn-sm segment-card-action-button"}
            onClick={this.onActivateLocks}
          >
            {I18n.t("reactivate_locks")}
          </button>
        );
      }
      return (
        <div
          className="col-md-6 flexed content-right button-wrapper"
          style={{ padding: "0px" }}
        >
          {buttons}
        </div>
      );
    }
  }

  renderBody() {
    const { reservation_segment } = this.props;

    if (reservation_segment) {
      var { room, status = "" } = reservation_segment;
    } else {
      var { room } = this.props;
    }

    if (!room && status === "active") {
      return (
        <div>
          <label>{I18n.t("status")}</label>
          <br />
          {I18n.t("not_checked_in")}
        </div>
      );
    }

    if (room && room.lock_management === "remotelock") {
      return this.renderRemoteLock(reservation_segment, room);
    } else if (room && room.lock_management === "manual_key_code") {
      return (
        <div>
          <Errors errors={this.state.errors} />
          <div className="row">
            <div className="col-md-6">
              <label>{I18n.t("lock_management")}</label>
              <br />
              {I18n.t("manually_set")}
            </div>
            {status === "checked_in" ? (
              <div className="col-md-6">
                <label>{I18n.t("pin_code")}</label>
                <br />
                {room ? room.pin_code : I18n.t("none")}
              </div>
            ) : null}
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <Errors errors={this.state.errors} />
          <div className="row">
            <div className="col-md-6">
              <label>{I18n.t("lock_management")}</label>
              <br />
              {I18n.t("none")}
            </div>
          </div>
        </div>
      );
    }
  }

  renderStatusText(status) {
    if (status === "active") {
      return I18n.t("not_checked_in");
    } else {
      return I18n.t(status);
    }
  }

  renderRemoteLock(reservation_segment) {
    if (reservation_segment) {
      const { status } = reservation_segment;

      var room_locks = reservation_segment.room_locks.filter((room_lock) => {
        return room_lock.reservation_segment_id === reservation_segment.id;
      });
      room_locks = room_locks.sort(function (a, b) {
        return (
          DateHelper.parseDateFromBackend(b.remotelock_start) -
          DateHelper.parseDateFromBackend(a.remotelock_start)
        );
      });
      const now = new Date();

      room_locks = room_locks.filter((room_lock) => {
        return isBefore(
          now,
          DateHelper.parseDateFromBackend(room_lock.remotelock_end)
        );
      });

      const room_lock = room_locks[0];

      if (this.state.show_activate_override) {
        return (
          <div className="alert alert-warning" style={{ marginBottom: "0px" }}>
            <div className="text-center" style={{ marginTop: "14px" }}>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label>
                  {I18n.t("activate_locks_until")}{" "}
                  <span
                    className="ss-help help"
                    title={I18n.t(
                      "remotelock_status_checked_out_override_warning"
                    )}
                  ></span>
                </label>
                <div style={{ maxWidth: "88px", margin: "0 auto" }}>
                  <TimePickerInput
                    onChange={this.onChangeOverrideCheckInTime}
                    format={this.props.time_format}
                    selectedTime={this.state.override_check_in_time}
                  />
                </div>
              </div>
            </div>
            <div className="text-center" style={{ marginTop: "14px" }}>
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                style={{ marginRight: "7px" }}
                onClick={this.onToggleShowActiveOverride}
              >
                {I18n.t("cancel")}
              </button>
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={this.onActivateLockOverride}
              >
                {I18n.t("activate_locks")}
              </button>
            </div>
          </div>
        );
      } else if (status === "checked_out") {
        return (
          <div>
            <Errors errors={this.state.errors} />
            <div className="row spacer">
              <div className="col-md-6">
                <label>{I18n.t("lock_management")}</label>
                <br />
                Remotelock
              </div>
              <div className="col-md-6">
                <label>{I18n.t("status")}</label>
                <br />
                {this.renderStatusText(status)}
                {room_lock ? (
                  <div>
                    <hr style={{ marginTop: "7px", marginBottom: "7px" }} />
                    {I18n.t("locks_active_from")}{" "}
                    {room_lock
                      ? this.renderAccessTimes(room_lock)
                      : I18n.t("none")}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <label>{I18n.t("devices")}</label>
                <br />
                {this.renderDevices()}
              </div>
              <div className="col-md-6">
                <label>{I18n.t("pin_code")}</label>
                <br />
                {room_lock ? room_lock.pin_code : I18n.t("none")}
              </div>
            </div>
          </div>
        );
      } else if (status === "active") {
        return (
          <div>
            <Errors errors={this.state.errors} />
            <div className="row spacer">
              <div className="col-md-6">
                <label>{I18n.t("lock_management")}</label>
                <br />
                Remotelock
              </div>
              <div className="col-md-6">
                <label>{I18n.t("status")}</label>
                <br />
                {I18n.t("not_checked_in")}
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <label>{I18n.t("devices")}</label>
                <br />
                {this.renderDevices()}
              </div>
              <div className="col-md-6">
                <label>{I18n.t("pin_code")}</label>
                <br />
                {I18n.t("none")}
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <div>
            <Errors errors={this.state.errors} />
            <div className="row spacer">
              <div className="col-md-6">
                <label>{I18n.t("lock_management")}</label>
                <br />
                Remotelock
              </div>
              <div className="col-md-6">
                <label>{I18n.t("start_and_end_dates")}</label>
                <br />
                {room_lock ? this.renderAccessTimes(room_lock) : I18n.t("none")}
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <label>{I18n.t("devices")}</label>
                <br />
                {this.renderDevices()}
              </div>
              <div className="col-md-6">
                <label>{I18n.t("pin_code")}</label>
                <br />
                {room_lock ? room_lock.pin_code : I18n.t("none")}
              </div>
            </div>
          </div>
        );
      }
    } else {
      return (
        <div>
          <Errors errors={this.state.errors} />
          <div className="row">
            <div className="col-md-6">
              <label>{I18n.t("lock_management")}</label>
              <br />
              Remotelock
            </div>
            <div className="col-md-6">
              <label>{I18n.t("devices")}</label>
              <br />
              {this.renderDevices()}
            </div>
          </div>
        </div>
      );
    }
  }

  renderDevices() {
    const { date_format, time_format, reservation_segment = {} } = this.props;
    const { status, room_locks = [] } = reservation_segment;
    const combined_format = `${date_format} ${time_format}`;
    const { devices } = this.state;

    if (devices && devices.length > 0) {
      return (
        <div>
          {devices.map((device) => {
            const room_lock = room_locks.find((room_lock) => {
              return room_lock.device_id === device.device_id;
            });
            const room_lock_created_at = room_lock && room_lock.created_at ? DateHelper.parseDateFromBackend(room_lock.created_at) : null;
            const device_connected_at = device && device.attributes ? DateHelper.parseDateFromBackend(device.attributes.connected_at) : null;

            return (
              <div key={device.id}>
                <div style={{ display: "flex", padding: "0" }}>
                  <strong
                    style={{
                      display: "inline-block",
                      marginRight: "2px",
                      fontWeight: "normal",
                    }}
                  >
                    <span
                      style={{
                        fontWeight: "bold",
                        fontSize: "15px",
                        display: "inline-block",
                        marginRight: "2px",
                        position: "relative",
                        top: "1px",
                      }}
                    >
                      &#8226;
                    </span>{" "}
                    {device && device.attributes ? device.attributes.name : ""}
                  </strong>{" "}
                  <BatteryStatus
                    power_level={device.attributes.power_level}
                    power_source={device.attributes.power_source}
                  />{" "}
                  <DeviceConnectionStatus
                    connected={device.attributes.connected}
                    wifi_level={device.attributes.wifi_level}
                    wifi_enabled={device.attributes.wifi_enabled}
                  />
                </div>
                {status === "checked_in" || status === "checked_out" ? (
                  <div style={{ fontSize: "10px", marginLeft: "10px" }}>
                    {I18n.t("last_sync")}:{" "}
                    {device_connected_at && room_lock_created_at && (device_connected_at >= room_lock_created_at) ? DateHelper.printDateToScreen(device_connected_at, combined_format) : I18n.t('pending')}
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      );
    } else if (devices && devices.length === 0) {
      return <div>{I18n.t("none")}</div>;
    } else {
      return <div>{I18n.t("loading")}</div>;
    }
  }

  /**
   * Change handlers
   */

  onActivateLocks(e) {
    const { reservation_segment = {} } = this.props;
    const { status } = reservation_segment;
    const { show_activate_override } = this.state;

    if (status === "checked_out") {
      this.setState({
        show_activate_override: !show_activate_override,
      });
    }
  }

  onActivateLockOverride(e) {
    e.preventDefault();
    e.stopPropagation();
    const { reservation_segment = {} } = this.props;
    this.setState({ loading: true, errors: [] });
    $.ajax({
      type: "POST",
      url: reservation_segment.remotelock_reactivate_locks_path,
      data: {
        override: true,
        starts_at: new Date().toISOString(),
        ends_at: this.state.override_check_in_time.toISOString(),
      },
    }).done((data) => {
      if (data && data.errors) {
        this.setState({
          errors: data.errors,
          loading: false,
          show_activate_override: false,
        });
      } else {
        this.setState(
          { errors: [], loading: false, show_activate_override: false },
          () => {
            ReservationSegmentCardActions.onReactivateLocks(data);
          }
        );
      }
    });
  }

  onChangeOverrideCheckInTime(time) {
    this.setState({ override_check_in_time: time });
  }

  onToggleShowActiveOverride(e) {
    e.preventDefault();
    e.stopPropagation();
    const { show_activate_override } = this.state;
    this.setState({
      show_activate_override: !show_activate_override,
    });
  }

  /**
   * Helper functions
   */

  getCheckInDate() {
    var {
      reservation_segment: { check_in_date, check_in_time },
    } = this.props;
    check_in_date = DateHelper.setDateToTime(check_in_date, check_in_time);
    return check_in_date;
  }

  getCheckOutDate() {
    var {
      reservation_segment: {
        check_out_date,
        check_out_time,
        remotelock_grace_period_in_minutes,
      },
    } = this.props;
    check_out_date = DateHelper.setDateToTime(check_out_date, check_out_time);
    check_out_date = addMinutes(
      check_out_date,
      remotelock_grace_period_in_minutes
    );
    return check_out_date;
  }

  getActualCheckOutDate() {
    var {
      reservation_segment: { checked_out_at },
    } = this.props;

    if (checked_out_at) {
      return DateHelper.parseDateFromBackend(checked_out_at);
    } else {
      return null;
    }
  }

  getLockStartDate(room_lock) {
    var { remotelock_start } = room_lock;
    return DateHelper.parseDate(remotelock_start);
  }

  getLockEndDate(room_lock) {
    var { remotelock_end } = room_lock;
    return DateHelper.parseDate(remotelock_end);
  }

  isRemoteLockActive(re) {
    const { reservation_segment } = this.props;
    var room_locks = reservation_segment.room_locks.filter((room_lock) => {
      return room_lock.reservation_segment_id !== reservation_segment.id;
    });
    room_locks = room_locks.sort(function (a, b) {
      return (
        DateHelper.parseDateFromBackend(b.remotelock_start) -
        DateHelper.parseDateFromBackend(a.remotelock_start)
      );
    });
    const now = new Date();

    room_locks = room_locks.filter((room_lock) => {
      return isBefore(
        now,
        DateHelper.parseDateFromBackend(room_lock.remotelock_end)
      );
    });

    return room_locks.length > 0;
  }

  isCheckOutDateInFuture() {
    const now = new Date();
    const check_out_date = this.getCheckOutDate();
    return (
      isBefore(now, check_out_date) ||
      isBefore(
        now,
        DateHelper.parseDate(
          this.props.reservation_segment.remotelock_end_datetime_override
        )
      )
    );
  }

  isCheckOutSameDay() {
    const now = new Date();
    const check_out_date = this.getCheckOutDate();
    const actual_check_out_date = this.getActualCheckOutDate();
    return (
      isSameDay(endOfDay(now), endOfDay(check_out_date)) ||
      isSameDay(endOfDay(now), endOfDay(actual_check_out_date))
    );
  }

  loadDevices() {
    $.ajax({
      type: "POST",
      url: this.props.reservation_segment
        ? this.props.reservation_segment.remotelock_get_room_devices_path
        : this.props.room.remotelock_get_room_devices_path,
    }).done((data) => {
      if (!data || (data && data.devices && data.devices.length === 0)) {
        this.setState({ devices: [] });
      } else {
        this.setState({ devices: data.devices });
      }
    });
  }
}
